// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__16lpJ","overflowing":"ReadFullNote_overflowing__1g_-O"};